import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';

export const mediaSchema = new schema.Entity(EntityTypes.Media);
